import { Routes } from '@angular/router';

import { AppGuardComponent } from '@app/app.guard';
import { AppRoutes } from '@rx-applications/clientsite/shared/router/data-access';
import { AuthGuard } from '@core/modules/auth/guards/auth.guard';
import { GuestGuard } from '@core/modules/auth/guards/guest.guard';
import { loadRemoteModule } from '@nx/angular/mf';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: AppRoutes.Book, pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./layout-app/layout-app.module').then((m) => m.LayoutAppModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./layout-auth/layout-auth.module').then((m) => m.LayoutAuthModule),
    canMatch: [
      GuestGuard,
      () => inject(ConfigFacade).useClientsiteAuthApp$.pipe(map((useClientsiteAuthApp) => !useClientsiteAuthApp)),
    ],
  },
  {
    path: '',
    loadChildren: () => loadRemoteModule('clientsite-auth', './Routes').then((m) => m.remoteRoutes),
    canMatch: [GuestGuard, () => inject(ConfigFacade).useClientsiteAuthApp$],
  },
  {
    path: '',
    loadChildren: () => import('./layout-error/layout-error.module').then((m) => m.LayoutErrorModule),
  },
  // Using a component because there is no option to use `canActivate` guard on path '**' in angular
  { path: '**', component: AppGuardComponent },
];
